


// You will import Theme 2 screens here later when you build them...

import BusBookingConfirmation1 from "./BusPanel/BusBookingConfirmation/BusBookingConfirmation1";
import BusBookingConfirmation2 from "./BusPanel/BusBookingConfirmation/BusBookingConfirmation2";
import BusPayment1 from "./BusPanel/BusPayment/BusPayment1";
import BusPayment2 from "./BusPanel/BusPayment/BusPayment2";
import BusResults3 from "./BusPanel/BusResults/BusResults3";
import BusResults1 from "./BusPanel/BusResults/BusResults1";
import BusResults2 from "./BusPanel/BusResults/BusResults2";
import BusSeatSelection1 from "./BusPanel/BusSeatSelection/BusSeatSelection1";
import BusSeatSelection2 from "./BusPanel/BusSeatSelection/BusSeatSelection2";
import SearchBus1 from "./BusPanel/SearchBus/SearchBus1";
import SearchBus2 from "./BusPanel/SearchBus/SearchBus2";
import SearchBus3 from "./BusPanel/SearchBus/SearchBus3";
import SearchBus4 from "./BusPanel/SearchBus/SearchBus4";
import FlightBookingConfirmation2 from "./FlightPanel/BookingDetails/FlightBookingConfirmation2";
import FlightDetails1 from "./FlightPanel/FlightDetails/FlightDetails1";
import FlightDetails2 from "./FlightPanel/FlightDetails/FlightDetails2";
import Flights1 from "./FlightPanel/Flights/Flights1";
import Flights2 from "./FlightPanel/Flights/Flights2";
import Flights4 from "./FlightPanel/Flights/Flights4";
import Flights5 from "./FlightPanel/Flights/Flights5";
import ReviewFlight2 from "./FlightPanel/ReviewFlight/ReviewFlight2";
import SearchFlight1 from "./FlightPanel/SearchFlight/SearchFlight1";
import SearchFlight2 from "./FlightPanel/SearchFlight/SearchFlight2";
import SearchFlight4 from "./FlightPanel/SearchFlight/SearchFlight4";
import SearchFlight5 from "./FlightPanel/SearchFlight/SearchFlight5";
import BusSeatSelection3 from "./BusPanel/BusSeatSelection/BusSeatSelection3";
import SearchFlightPanel6 from "./FlightPanel/SearchFlightPanel/SearchFlightPanel6";
import SearchFlightPanel7 from "./FlightPanel/SearchFlightPanel/SearchFlightPanel7";
import SearchFlightPanel8 from "./FlightPanel/SearchFlightPanel/SearchFlightPanel8";
import Flights6 from "./FlightPanel/Flights/Flights6";

export const moduleThemes = {
  flights: {
    FlightTheme1: {
      search: SearchFlight1,
      results: Flights1,
      details: FlightDetails1,
    },
    FlightTheme2: { 
        search: SearchFlight2, 
        results: Flights2, 
        details: FlightDetails2,
        review: ReviewFlight2,           // 👈 ADDED
       confirmation: FlightBookingConfirmation2
     },
     FlightTheme4: {
        search: SearchFlight4,
        results: Flights4,
  },
  FlightTheme5: {
    search: SearchFlight5,
    results: Flights5,
  },
  FlightTheme6: {
    search: SearchFlightPanel6,
    results: Flights6,
    
  },
  FlightTheme7: {
    search: SearchFlightPanel7,
    
  },
   FlightTheme8: {
    search: SearchFlightPanel8,
    
  },
  },
  hotels: {
    HotelTheme1: {
      // search: SearchHotel1, results: Hotels1, details: HotelDetails1
    }
  },
  buses: { 
    BusTheme1: {
    search: SearchBus1,
    results: BusResults1,
    seats: BusSeatSelection1 ,
     payment: BusPayment1,
     confirmation: BusBookingConfirmation1
    },
BusTheme2: {
    search: SearchBus2,
    results: BusResults2,
    seats: BusSeatSelection2,
     payment: BusPayment2,
     confirmation: BusBookingConfirmation2
    },
    BusTheme3: {
    search: SearchBus3,
    results: BusResults3,
    seats: BusSeatSelection3 ,

    },
    BusTheme4: {
    search: SearchBus4,
    results: BusResults1,
    }
  }
  // visas: { ... }, 
  // buses: { ... }
};